/* @flow */

import * as React from 'react';
import { every, get, noop, some } from 'lodash/fp';
import styled from '@emotion/styled';

import PlayerPositionTab from 'app/components/challenge/PlayerPositionTab';
import t from 'app/utils/translate';

const allFilled = every('filled');
const containsError = some('hasError');

type Props = {
  // autoAdvancePositions?: boolean,
  onSelect?: (string | null) => void,
  positions: Array<Object>,
  requiredSelections?: number,
  selectedPositions?: Array<string>,
  showSelectionFeedback?: boolean,
  totalSelected?: number,
  isCaptainContest: boolean
};

const PlayerPositionsNav = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  overflow: 'scroll',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
  [theme.mediaQuery.desktopAndUp]: {
    overflow: 'hidden'
  }
}));

class PlayerPositionsBar extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    // autoAdvancePositions: false,
    onSelect: noop,
    requiredSelections: 0,
    selectedPositions: [],
    showSelectionFeedback: false,
    totalSelected: 0
  };

  render() {
    const {
      onSelect,
      positions,
      requiredSelections,
      selectedPositions,
      showSelectionFeedback,
      totalSelected,
      isCaptainContest
    } = this.props;

    const captainDefaultPosition = pos => {
      if (selectedPositions.length === 0 && positions.indexOf(pos) === 0) {
        onSelect(pos.id); // set this to the default position
        return true;
      }
      if (selectedPositions.includes(pos.id)) {
        return true;
      }
      return false;
    };

    return (
      <PlayerPositionsNav>
        {!isCaptainContest && (
          <PlayerPositionTab
            enabled={selectedPositions.length === 0}
            filled={requiredSelections === totalSelected && allFilled(positions)}
            hasError={containsError(positions)}
            label={t('All')}
            max={requiredSelections}
            min={requiredSelections}
            onSelect={() => onSelect(null)}
            selected={totalSelected}
          />
        )}
        {positions.map(pos => {
          if (pos.shareQuota && pos.isTeam) {
            return null;
          }
          let { selected } = pos;
          if (pos.shareQuota && !pos.isTeam) {
            const teamPos = positions.find(p => p.id === pos.id && p.isTeam);
            selected += get('selected', teamPos) || 0;
          }
          return (
            <PlayerPositionTab
              key={pos.id}
              enabled={
                isCaptainContest ? captainDefaultPosition(pos) : selectedPositions.includes(pos.id)
              }
              filled={pos.filled}
              hasError={pos.hasError}
              label={pos.abbr}
              max={pos.max}
              min={pos.min}
              onSelect={() => onSelect(pos.id)}
              selected={selected}
              showSelectionFeedback={showSelectionFeedback}
            />
          );
        })}
      </PlayerPositionsNav>
    );
  }
}

export default PlayerPositionsBar;
